module.exports = __webpack_public_path__ + "img/2.3ea28a8c.jpg";